import React from "react";
import LineChart from "../../../../etc/LineChart";

const RCitation = (parent) => {
    const record = parent.record;
    let status = false;
    if(record.cite_date_info) {
        Object.keys(record.cite_date_info).map((item,num) => {
            if(record.cite_date_info[item]) {
                status = true;
            }
        });
    }

    if(!status)
        return '';

    return (
        <div className="mt-6">
            <div className="d-flex justify-content-between align-items-center mb-px-26">
                <div className="d-flex align-items-center">
                    <h3 className="con-title">인용정보</h3>
                </div>
            </div>
            <div className="pt-4 pb-4 border-top border-bottom border-lightgray">
                <h3 className="detail-title text-center mb-4">누적피인용 횟수 피인용 예측</h3>
                <div className="standard-data-list">
                    <div className="standard-item">
                        <div className="item-title color-lightpurple"><strong>WOS 24</strong></div>
                        <div className="item-date">2021.02.24 기준</div>
                    </div>
                    <div className="standard-item">
                        <div className="item-title color-lightorange"><strong>Scopus 24</strong></div>
                        <div className="item-date">2021.02.24 기준</div>
                    </div>
                    <div className="standard-item">
                        <div className="item-title color-lightgreen"><strong>KCI 24</strong></div>
                        <div className="item-date">2021.02.24 기준</div>
                    </div>
                </div>
                {/*<div className="d-flex justify-content-between align-items-center mt-5 mb-4">*/}
                {/*    <div className="font-size-12 color-lightblack">저널 반감기를 통해 예측한 피인용횟수로실제와 다를 수 있습니다.<br />참고용으로만 사용하시기 바랍니다.</div>*/}
                {/*    <div className="d-flex align-items-center">*/}
                {/*        <div className="chart-label mr-4">*/}
                {/*            <div className="label-color bg-lightpurple"></div>*/}
                {/*            <div className="label-subject">WOS</div>*/}
                {/*        </div>*/}
                {/*        <div className="chart-label mr-4">*/}
                {/*            <div className="label-color bg-lightorange"></div>*/}
                {/*            <div className="label-subject">Scopus</div>*/}
                {/*        </div>*/}
                {/*        <div className="chart-label">*/}
                {/*            <div className="label-color bg-lightgreen"></div>*/}
                {/*            <div className="label-subject">KCI</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="line-chart-data">*/}
                {/*    <LineChart records={result} />*/}
                {/*</div>*/}
            </div>
        </div>
    );
};

export default RCitation;
